import { ChangeEvent, useEffect, useState } from "react";
import React from "react";
import { warningAlert } from "@hooks/HelperHook";
import { resolveImageUrl } from "@helpers/image.helper";

type Props = {
    onChange: (file: File) => void,
    url: string
}

function BannerPicker({ onChange, url }: Props) {
    const [selectedFile, setSelectedFile] = useState<string | undefined>(undefined);

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        if ((event.target.files?.length || 0) > 0) {
            const file = event.target.files![0];
            const size = file.size / 1024 / 1024;
            if (size < 5) {
                setSelectedFile(URL.createObjectURL(file));
                if (onChange) onChange(file)
            } else {
                warningAlert("File must be under 5Mb")
            }
        }
    };

    return <>
        <div className="relative bg-gray-900">
            <img src={resolveImageUrl(!selectedFile ? url : selectedFile)} alt="banner" className="h-[18.75rem] object-cover mx-auto" />
            <div className="container relative -translate-y-4">
                <div
                    className="group absolute right-0 bottom-4 flex items-center rounded-lg bg-white py-2 px-4 font-display text-sm hover:bg-jacarta-500"
                >
                    <input onChange={handleFileChange} type="file" accept="image/*" className="absolute inset-0 cursor-pointer opacity-0" />
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="mr-1 h-4 w-4 fill-jacarta-400 group-hover:fill-white"
                    >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path
                            d="M15.728 9.686l-1.414-1.414L5 17.586V19h1.414l9.314-9.314zm1.414-1.414l1.414-1.414-1.414-1.414-1.414 1.414 1.414 1.414zM7.242 21H3v-4.243L16.435 3.322a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L7.243 21z"
                        ></path>
                    </svg>
                    <span className="mt-0.5 block group-hover:text-white">Edit banner</span>
                </div>
            </div>
        </div>
    </>
}

export default BannerPicker;